var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('div',{staticClass:"d-flex"},[_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":_vm.handleAdd}})],1),_c('List',{ref:"list",on:{"select":_vm.handleEdit}}),_c('Form',{ref:"form",on:{"refresh":_vm.refresh}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }